import { PageViewEventLogger } from '@repo/tracking-service';
import { AuthGuard } from '@repo/user-session';
import { GetServerSideProps } from 'next';

import Layout from '@/components/layout/Layout';
import { LookupResultContextProvider } from '@/components/tax-refund/lookup/result/LookupResultContext';
import { PoaSubmit } from '@/components/tax-refund/power-of-attorney/PoaSubmit';
import { BusinessType } from '@/lib/types/request';

const PowerOfAttorneySubmitPage = ({ businessType }: { businessType: BusinessType }) => {
  return (
    <AuthGuard>
      <PageViewEventLogger pageName={'request_after_autograph'}>
        <LookupResultContextProvider businessType={businessType}>
          <Layout leftIcon={{ icon: 'back', clickEvent: { name: 'request_back' } }} mainClassName={'flex flex-col items-center'}>
            <PoaSubmit businessType={businessType} />
          </Layout>
        </LookupResultContextProvider>
      </PageViewEventLogger>
    </AuthGuard>
  );
};

export default PowerOfAttorneySubmitPage;

export const getServerSideProps = (async ({ query }) => {
  if (query?.type) {
    return { props: { businessType: query?.type as BusinessType } };
  }
  return { props: { businessType: '' } };
}) satisfies GetServerSideProps;
